import React, { useState, useEffect } from 'react';
import classnames from "classnames";
import { observer } from 'mobx-react';
import { UserModel, TinetsConfigModels } from "shared/models";
import { useStore, useMedia } from "shared/hooks";
import { Helpers } from "shared/utilities";
import { ICONS } from "shared/constants";
import { UiIcon, UiModal } from 'shared/uikit';
import { tinetsConfigQuery } from "shared/queries";
import { ApplicationModule } from "shared/modules";

import './styles.scss';

type PropsType = {
    user: UserModel,
    isProfile: boolean
}

export const PProfileTinets = observer(({ user, isProfile }: PropsType) => {
    const store = useStore(() => ({
        isOpen: false,
    }));

    const stoereTinets = useStore(() => new TinetsConfigModels());

    useEffect(() => {
        (async () => {
            const { isSuccess: successTinets, data: dataTinets } = await tinetsConfigQuery();

            if (successTinets && dataTinets) {
                stoereTinets.set('levels', dataTinets.levels);
                stoereTinets.set('tasks', dataTinets.tasks);
            }
        })();
    }, [stoereTinets]);

    const { isMobileOrTablet } = useMedia();

    const labelTinnet = (tinnetCount: number) => {
        return Helpers.pluralize(tinnetCount, ["тинетка", "тинетки", "тинеток"])
    }

    const getIconStar = () => {
        switch (user.userRatingPosition) {
            case 1:
                return "TINNET_STAR_GOLD"
            case 2:
                return "TINNET_STAR_SILVER"
            case 3:
                return "TINNET_STAR_BRONZE"
            default:
                return "";
        }
    }

    const getNextLevel = () => {
        let nextLevel = 0;
        let nextLevelCount = 0
        let tinetToNextLevel = 0;

        if (stoereTinets?.levels) {
            if (user.userTinetsCount < 0) {
                nextLevel = 2;
                nextLevelCount = stoereTinets?.levels[1] ? stoereTinets?.levels[1].tinetsRequired : 0;
                tinetToNextLevel = Math.abs(user.userTinetsCount) + (stoereTinets?.levels[1] ? stoereTinets?.levels[1].tinetsRequired : 0);
            } else {
                for (let index = 0; index < stoereTinets?.levels.length; index++) {
                    const element = stoereTinets?.levels[index];

                    if (element.tinetsRequired > user.userTinetsCount) {
                        nextLevel = element.level;
                        nextLevelCount = element.tinetsRequired;
                        tinetToNextLevel = element.tinetsRequired - user.userTinetsCount;
                        break;
                    }
                }
            }
        }

        return {
            nextLevel,
            nextLevelCount,
            tinetToNextLevel,
        }
    }

    const widthProgressBar = (countTinet: number) => {
        const lastTinets = stoereTinets?.levels?.[stoereTinets?.levels?.length - 1].tinetsRequired;

        if (lastTinets && countTinet) {
            return (countTinet * 100) / lastTinets + "%";
        } else {
            return "0";
        }
    }

    const levelListMobile = () => {
        const { nextLevel } = getNextLevel();

        const res = stoereTinets?.levels?.filter(item => {
            if (item.level === user.userLevel) {
                return item;
            }

            if (isLastLevel()) {
                const lastLevel = stoereTinets?.levels?.[stoereTinets?.levels?.length - 1].level ?? 1;

                if (item.level === lastLevel - 1) {
                    return item;
                }
            } else {
                if (item.level === nextLevel) {
                    return item;
                }
            }
        })

        return res
    }

    const widthProgressBarMobile = () => {
        const currentLevelCount = stoereTinets?.levels?.find(item => item.level === user.userLevel)?.tinetsRequired ?? 0;

        const { nextLevelCount } = getNextLevel();

        if (!isLastLevel()) {
            const start = user.userTinetsCount - currentLevelCount;
            const end = nextLevelCount - currentLevelCount;

            return (start * 100) / end  + "%";
        } else {
            return "100%";
        }
    }

    const isCompleteTask = (idTask: number) => {
        return user.arrayIdCompletedTask.includes(idTask) ? true : false;
    }

    const classCompleteTask = (tinetCount: number) => {
        return tinetCount < 0 ? "task-item--red" : "task-item--green";
    }

    const isLastLevel = () => {
        return user.userLevel === stoereTinets?.levels?.[stoereTinets?.levels?.length - 1]?.level;
    }

    const lastLevel = () => {
        return stoereTinets?.levels?.[stoereTinets?.levels?.length - 1]?.level;
    }

    const calcTinetTask = (id: number, tinetsDelta: number) => {
        const countCompletedTask = user.arrayIdCompletedTask.filter(item => item === id)?.length;

        return countCompletedTask ? countCompletedTask * tinetsDelta : tinetsDelta;
    }

    return (
        <>
            <div className={classnames("p-user-section p-user-section--tinnet", { " p-user-section--pointer": ApplicationModule.user.id === user.id })} onClick={() => store.set('isOpen', true)}>
                <div className="p-user-tinnet">
                    <div className="p-user-tinnet__list">
                        {Array.from({ length: user.userLevel }).map((_, i) => (
                            <div key={i} className="p-user-tinnet__item"></div>
                        ))}
                    </div>

                    <div className="p-user-tinnet__info">
                        <div className="p-user-tinnet__level">Дизайнер {user.userLevel}-го уровня</div>

                        <div className="p-user-tinnet__group">
                            <span>{user.userTinetsCount} {labelTinnet(user.userTinetsCount)}</span>
                            <span>{user.userCompletedTasksCount} {Helpers.pluralize(user.userCompletedTasksCount ?? 0, ["достижение", "достижения", "достижений"])}</span>
                        </div>
                    </div>

                    {
                        ApplicationModule.user.id === user.id ?
                            <UiIcon
                                size={16}
                                icon={ICONS["ARROR_RIGHT"]}
                            />
                            : ''
                    }

                </div>
            </div>
            {
                ApplicationModule.user.id === user.id && user.tinetsUserStat && stoereTinets?.tasks?.length && stoereTinets?.levels?.length ?
                    <UiModal isOpened={store.isOpen} onClose={() => store.set('isOpen', false)} className={"ui-modal-achievement"}>
                        <div className="modal-achievement">
                            <div className="modal-achievement__title">
                                Дизайнер {user.userLevel}-го уровня

                                {
                                    getIconStar() && (
                                        <div className="modal-achievement__star">
                                            <UiIcon
                                                size={24}
                                                icon={ICONS[getIconStar() as keyof typeof ICONS]}
                                            />
                                        </div>
                                    )
                                }
                            </div>

                            <div className="modal-achievement__scroll">
                                <div className="modal-achievement__top">
                                    <div className="modal-achievement__tinnet">
                                        <div className="modal-achievement__tinnet-list">
                                            {Array.from({ length: user.userLevel }).map((_, i) => (
                                                <div key={i} className="modal-achievement__tinnet-item"></div>
                                            ))}
                                        </div>

                                        <div className="modal-achievement__tinnet-info">
                                            <div className="modal-achievement__tinnet-title">{user.userTinetsCount} {labelTinnet(user.userTinetsCount)}</div>
                                            <div className="modal-achievement__tinnet-level">
                                                {
                                                    isLastLevel() ?
                                                        'Максимальный уровень'
                                                        :
                                                        `Еще ${ getNextLevel().tinetToNextLevel } ${labelTinnet(getNextLevel().tinetToNextLevel)} до ${getNextLevel().nextLevel}-го уровня`
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        isMobileOrTablet ?
                                            <div className="modal-achievement__progress mobile">
                                                <div className="modal-achievement__progress-line">
                                                    <div className="modal-achievement__progress-bar" style={{ width: widthProgressBarMobile() }}></div>
                                                </div>
                                                <div className="modal-achievement__progress-list">
                                                    {
                                                        levelListMobile()?.map((item, index) => (
                                                            <div key={item.level} className={classnames("modal-achievement__progress-item", {"modal-achievement__progress-item--active": item.level < getNextLevel().nextLevel || isLastLevel()})} style={{ left: index === 0 ? "0%" : "100%" }}>
                                                                <div className="modal-achievement__progress-item-level">
                                                                    {
                                                                        item.level === lastLevel() ?
                                                                            "MAX" :
                                                                            item.level + " ур."
                                                                    }
                                                                </div>
                                                                <div className="modal-achievement__progress-item-tinet">{ item.tinetsRequired } {labelTinnet(item.tinetsRequired)}</div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                            :
                                            <div className="modal-achievement__progress desktop">
                                                <div className="modal-achievement__progress-line">
                                                    <div className="modal-achievement__progress-bar" style={{ width: widthProgressBar(user.userTinetsCount) }}></div>
                                                </div>
                                                <div className="modal-achievement__progress-list">
                                                    {
                                                        stoereTinets?.levels?.map(item => (
                                                            <div key={item.level} className={classnames("modal-achievement__progress-item", {"modal-achievement__progress-item--active": item.level < getNextLevel().nextLevel || isLastLevel()})} style={{ left: widthProgressBar(item.tinetsRequired) }}>
                                                                <div className="modal-achievement__progress-item-level">
                                                                    {
                                                                        item.level === lastLevel() ?
                                                                            "MAX" :
                                                                            item.level + " ур."
                                                                    }
                                                                </div>
                                                                <div className="modal-achievement__progress-item-tinet">{ item.tinetsRequired } {labelTinnet(item.tinetsRequired)}</div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                    }
                                </div>

                                <div className="modal-achievement__task">
                                    <div className="modal-achievement__task-info">{user.userCompletedTasksCount} из {stoereTinets?.tasks?.length} получено</div>

                                    <div className="modal-achievement__task-list">
                                        {
                                            stoereTinets?.tasks?.map(item => (
                                                <div key={item.id} className={classnames("modal-achievement__task-item task-item", { "task-item--complete": isCompleteTask(item.id) }, isCompleteTask(item.id) ? classCompleteTask(item.tinetsDelta) : '' )}>
                                                    <div className="task-item__icon">
                                                        <UiIcon
                                                            size={11}
                                                            icon={ICONS["TASK_ITEM_ICON"]}
                                                        />
                                                    </div>

                                                    <div className="task-item__info">
                                                        <div className="task-item__name">{item.title}</div>
                                                        <div className="task-item__stauts">
                                                            {
                                                                isCompleteTask(item.id) ? "Получено" : "Не получено"
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="task-item__tinet">
                                                        {
                                                            item.tinetsDelta < 0 ?
                                                                (
                                                                    <>
                                                                        <span className='minus'>
                                                                            <UiIcon
                                                                                size={14}
                                                                                color={isCompleteTask(item.id) ? "#F43F5E" : "#2c2f35"}
                                                                                icon={ICONS["MINUS"]}
                                                                            />
                                                                        </span>
                                                                        {Math.abs(calcTinetTask(item.id, item.tinetsDelta))}
                                                                    </>
                                                                )
                                                                :
                                                                (
                                                                    <>
                                                                        <span className='plus'>
                                                                            {
                                                                                isCompleteTask(item.id) && (
                                                                                    <UiIcon
                                                                                        size={14}
                                                                                        color={"#22C55E"}
                                                                                        icon={ICONS["PLUS_SMALL"]}
                                                                                    />
                                                                                )
                                                                            }
                                                                        </span>
                                                                        {calcTinetTask(item.id, item.tinetsDelta)}
                                                                    </>
                                                                )
                                                        }
                                                    </div>
                                                </div>
                                            ))
                                        }

                                    </div>
                                </div>
                            </div>

                        </div>
                    </UiModal>
                    : ""
            }
        </>
    );
});
